import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMonument, faImages, faMapMarkerAlt, faHashtag, faLandmark, faTimes } from '@fortawesome/free-solid-svg-icons';
import footerBg from "../../assets/footerbg.jpg";
import amb1 from "./../../assets/Ambala/amb1.jpeg";
import amb2 from "./../../assets/Ambala/amb2.jpeg";
import amb3 from "./../../assets/Ambala/amb3.jpeg";
import amb4 from "./../../assets/Ambala/amb4.jpeg";
import amb5 from "./../../assets/Ambala/amb5.jpeg";
import amb6 from "./../../assets/Ambala/amb6.jpeg";
import amb7 from "./../../assets/Ambala/amb7.jpeg";
import amb8 from "./../../assets/Ambala/amb8.jpeg";
import amb9 from "./../../assets/Ambala/amb9.jpeg";
import bhi1 from "./../../assets/Bhiwani/bhi1.jpeg";
import bhi2 from "./../../assets/Bhiwani/bhi2.jpeg";
import bhi3 from "./../../assets/Bhiwani/bhi3.jpeg";
import bhi4 from "./../../assets/Bhiwani/bhi4.jpeg";
import bhi5 from "./../../assets/Bhiwani/bhi5.jpeg";
import cd1 from "./../../assets/Charkhi Dadri/cd1.jpeg";
import cd2 from "./../../assets/Charkhi Dadri/cd2.jpeg";
import cd3 from "./../../assets/Charkhi Dadri/cd3.jpeg";
import fa1 from "./../../assets/Faridabad/fa1.jpg";
import fa2 from "./../../assets/Faridabad/fa2.jpg";
import fa3 from "./../../assets/Faridabad/fa3.jpg";
import fa4 from "./../../assets/Faridabad/fa4.jpg";
import fa5 from "./../../assets/Faridabad/fa5.jpg";
import fa6 from "./../../assets/Faridabad/fa6.jpg";
import hi1 from "./../../assets/Hisar/hi1.jpeg";
import hi3 from "./../../assets/Hisar/hi2.jpeg";
import hi4 from "./../../assets/Hisar/hi3.jpeg";
import hi2 from "./../../assets/Hisar/hi4.jpeg";
import hi5 from "./../../assets/Hisar/hi5.jpeg";
import ji1 from "./../../assets/Jind/ji1.jpg";
import ji2 from "./../../assets/Jind/ji2.jpg";
import ji3 from "./../../assets/Jind/ji3.jpg";
import ji4 from "./../../assets/Jind/ji4.jpg";
import ji5 from "./../../assets/Jind/ji5.jpg";
import ji6 from "./../../assets/Jind/ji6.jpg";
import ka1 from "./../../assets/Karnal/ka1.jpeg";
import ka2 from "./../../assets/Karnal/ka2.jpeg";
import ka3 from "./../../assets/Karnal/ka3.jpeg";
import ka4 from "./../../assets/Karnal/ka4.jpeg";
import ka5 from "./../../assets/Karnal/ka5.jpeg";
import ku1 from "./../../assets/Kurukshetra/1.jpg";
import ku2 from "./../../assets/Kurukshetra/3.jpg";
import ku3 from "./../../assets/Kurukshetra/4.jpg";
import ku4 from "./../../assets/Kurukshetra/5.jpg";
import na1 from "./../../assets/Narnaul/1.jpg";
import na2 from "./../../assets/Narnaul/2.jpg";
import na3 from "./../../assets/Narnaul/3.jpg";
import pa1 from "./../../assets/Palwal/1.jpeg";
import pa2 from "./../../assets/Palwal/2.jpeg";
import pa3 from "./../../assets/Palwal/3.jpeg";
import pa4 from "./../../assets/Palwal/4.jpeg";
import pn1 from "./../../assets/Panipat/1.JPG";
import ro1 from "./../../assets/Rohtak//img1.png";

import BaseUrl from "../../base-api";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import {
  Table,
  Container,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  CardBody,
  Card,
} from "reactstrap";
import AxiosInstance from "../Utility/AxiosInstance";
import { handleAxiosError } from "../Utility/handleAxiosError";
import { useDispatch } from "react-redux";

import { isloading } from "../redux/reducer/LoadingReducer";

// FadeUp Component for scroll animations
const FadeUp = ({ children, delay = 0 }) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(ref.current);
        }
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return (
    <div
      ref={ref}
      style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(40px)',
        transition: `opacity 0.6s ease ${delay}s, transform 0.6s ease ${delay}s`,
      }}
    >
      {children}
    </div>
  );
};

const data = [
  {
    location: "Ambala",
    memorial: "Distt Level-1",
    images: [amb1, amb2, amb3, amb4, amb5, amb6, amb7, amb8, amb9],
  },
  {
    location: "Bhiwani",
    memorial: "Distt Level-1",
    images: [bhi1, bhi2, bhi3, bhi4, bhi5],
  },
  {
    location: "Charkhi Dadri",
    memorial: "Distt Level-1",
    images: [cd1, cd2, cd3],
  },
  {
    location: "Faridabad",
    memorial: "Distt Level-1",
    images: [fa1, fa2, fa3, fa4, fa5, fa6],
  },
  { location: "Fatehabad", memorial: "Nil", images: [] },
  { location: "Gurugram", memorial: "Distt Level-1", images: [] },
  {
    location: "Hisar",
    memorial: "Distt Level-1",
    images: [hi1, hi2, hi3, hi4, hi5],
  },
  { location: "Jhajjar", memorial: "Distt Level-1", images: [] },
  {
    location: "Jind",
    memorial: "Distt Level-1",
    images: [ji1, ji2, ji3, ji4, ji5, ji6],
  },
  { location: "Kaithal", memorial: "Distt Level-1", images: [] },
  {
    location: "Karnal",
    memorial: "Distt Level-1",
    images: [ka1, ka2, ka3, ka4, ka5],
  },
  {
    location: "Kurukshetra",
    memorial: "Distt Level-1",
    images: [ku1, ku2, ku3, ku4],
  },
  {
    location: "Mahendragarh",
    memorial: "Distt Level-1",
    images: [na1, na2, na3],
  },
  { location: "Nuh", memorial: "Nil", images: [] },
  { location: "Palwal", memorial: "Nil (Municipal Committee)", images: [pa1, pa2, pa3, pa4] },
  { location: "Panchkula", memorial: "Distt Level-1", images: [] },
  { location: "Panipat", memorial: "Distt Level-1", images: [pn1] },
  { location: "Rewari", memorial: "Distt Level-1", images: [] },
  { location: "Rohtak", memorial: "State Level-1 , Distt Level-1", images: [ro1] },
  { location: "Sirsa", memorial: "Distt Level-1", images: [] },
  { location: "Sonipat", memorial: "Distt Level-1", images: [] },
  { location: "Yamunanagar", memorial: "Nil", images: [] },
];

const WarMemorials = () => {
  const location = useLocation();
  const [items, setItems] = useState([]);
const dispatch=useDispatch()
  const [modalShow, setModalShow] = useState(false);
  const [selectedMemorial, setSelectedMemorial] = useState(null);

  const handleShowModal = (memorial) => {
    setSelectedMemorial(memorial);
    setModalShow(true);
  };

  const handleCloseModal = () => {
    setModalShow(false);
    setSelectedMemorial(null);
  };

  useEffect(() => {
    const fetchData = async () => {
      dispatch(isloading())
      try {
        const res = await AxiosInstance.post(
          `${BaseUrl}/api/v1/files/getImages`,
          { location: "War Memorial" },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (res.data.status === 200) {
          const processedImages = res.data.data.content.map((img, index) => ({
            src: img.file ? `data:image/png;base64,${img.file}` : "",
            key: index + 1,
          }));
          setItems(processedImages);
        } else {
          console.log(res.data.message || "Failed to load images.");
        }
      } catch (error) {
        handleAxiosError(error);
      } finally {
        dispatch(isloading())
      }
    };

    if (location.pathname) fetchData();
  }, [location.pathname]);

  return (
    <>
      {/* Header Section - Matching WhoWho Theme */}
      <div style={{
        backgroundImage: `url(${footerBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '30px 0',
        color: 'white',
        margin:'2%',
        borderRadius:'10px'
      }}>
        <Container>
          <h3 className="fw-bold mb-0 text-center">
            <FontAwesomeIcon icon={faMonument} className="me-2" />
            State Level & District Level War Memorials
          </h3>
        </Container>
      </div>

      <div className="container-fluid px-5 mb-3">
        <FadeUp>
        <div className="mb-4 p-4" style={{
          background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%)',
          borderRadius: '12px',
          borderLeft: '4px solid #1e3c72'
        }}>
          <p style={{color: '#495057', marginBottom: 0, lineHeight: '1.8'}}>
            <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2" style={{color: '#1e3c72'}} />
            A State War Memorial in Rohtak and 18 District War Memorials have been
            built across Haryana to honour war heroes who made supreme sacrifices
            for the Nation. War memorials are structures, statues, or monuments
            created to commemorate war victories or honour martyrs and those
            injured in war. Currently, there are a total of 22 War Memorials in
            Haryana.
          </p>
        </div>
        </FadeUp>
        <div className="row justify-content-center">
          {items.length > 0 &&
            items.map((img, idx) => (
              <div className="col-lg-4 col-md-6 mb-4" key={idx}>
                <FadeUp delay={idx * 0.1}>
                <div
                  className="mx-2 h-100"
                  style={{
                    borderRadius: "12px",
                    overflow: 'hidden',
                    background: 'white',
                    transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                    cursor: 'pointer',
                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)'
                  }}
                
                >
                  <div style={{
                    position: 'relative',
                    overflow: 'hidden',
                    borderRadius: "12px"
                  }}>
                    <img
                      src={img.src}
                      alt="War Memorial"
                      className="school-image"
                      width="100%"
                      height="280px"
                      style={{ 
                        borderRadius: "12px",
                        objectFit: "contain",
                        transition: 'transform 0.5s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.1)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                      }}
                    />
                  </div>
                </div>
                </FadeUp>
              </div>
            ))}
        </div>

        <FadeUp delay={0.2}>
        <Container className="py-4">
          <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
            <div style={{
              background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
              padding: '25px',
              color: 'white'
            }}>
              <h4 className="fw-bold mb-0">
                <FontAwesomeIcon icon={faLandmark} className="me-2" />
                District War Memorials
              </h4>
            </div>
            <CardBody className="p-4">
              <div className="table-responsive">
                <Table bordered hover className="mb-0">
                  <thead>
                    <tr>
                      <th style={{ background: '#1e3c72', color: 'white', width: '8%' }}>S.No.
                      </th>
                      <th style={{ background: '#1e3c72', color: 'white', width: '25%' }}>District</th>
                      <th style={{ background: '#1e3c72', color: 'white', width: '32%' }}>
                        War Memorial
                      </th>
                      <th style={{ background: '#1e3c72', color: 'white', width: '35%', textAlign: 'center' }}>
                        Images
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((item, index) => (
                      <tr key={index}>
                        <td style={{ color: '#495057', textAlign: 'center' }}>
                          <span >
                            {index + 1}
                          </span>
                        </td>
                        <td >
                          {item.location}
                        </td>
                        <td >
                          {item.memorial}
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          {item.images.length !== 0 ? (
                            <Button
                              style={{
                                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                                border: 'none',
                                borderRadius: '20px',
                                padding: '6px 15px',
                                fontSize: '14px',
                                fontWeight: '600',
                                width: window.innerWidth < 768 ? '100%' : '40%'
                              }}
                              onClick={() => handleShowModal(item)}
                              onMouseOver={(e) => {
                                e.currentTarget.style.background = 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)';
                                e.currentTarget.style.transform = 'scale(1.05)';
                              }}
                              onMouseOut={(e) => {
                                e.currentTarget.style.background = 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)';
                                e.currentTarget.style.transform = 'scale(1)';
                              }}
                            >
                              <FontAwesomeIcon icon={faImages} className="me-2" />
                              View Images
                            </Button>
                          ) : (
                            <span style={{ color: '#6c757d' }}>-</span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </CardBody>
          </Card>
        </Container>
        </FadeUp>

        {selectedMemorial && (
          <Modal
            isOpen={modalShow}
            toggle={handleCloseModal}
            size="lg"
            centered
          >
            <ModalHeader
              toggle={handleCloseModal}
              style={{
                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                color: 'white',
                border: 'none'
              }}
            >
              <FontAwesomeIcon icon={faMonument} className="me-2" />
              War Memorial <span style={{color: '#fff'}}>{selectedMemorial.location}</span> Images
            </ModalHeader>
            <ModalBody className="p-0">
              <div
                id="carouselExampleAutoplaying"
                className="carousel slide"
                data-bs-ride="carousel"
              >
                <div className="carousel-indicators">
                  {selectedMemorial.images.map((_, idx) => (
                    <button
                      key={idx}
                      type="button"
                      data-bs-target="#carouselExampleAutoplaying"
                      data-bs-slide-to={idx}
                      className={idx === 0 ? 'active' : ''}
                      style={{
                        backgroundColor: idx === 0 ? '#1e3c72' : '#6c757d',
                        border: 'none',
                        width: '12px',
                        height: '12px',
                        borderRadius: '50%',
                        margin: '0 5px'
                      }}
                      aria-current={idx === 0 ? 'true' : 'false'}
                      aria-label={`Slide ${idx + 1}`}
                    ></button>
                  ))}
                </div>
                <div className="carousel-inner">
                  {selectedMemorial.images.map((image, index) => (
                    <div
                      className={`carousel-item  ${
                        index === 0 ? "active" : ""
                      }`}
                      key={index}
                    >
                      <img
                        src={image}
                        className="d-block mx-auto"
                        alt={`image-${index}`}
                        style={{
                          height: '350px',
                          width: 'auto',
                          maxWidth: '100%',
                          objectFit: 'contain'
                        }}
                      />
                    </div>
                  ))}
                </div>
                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#carouselExampleAutoplaying"
                  data-bs-slide="prev"
                  style={{ opacity: '0.8' }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.opacity = '1';
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.opacity = '0.8';
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }}
                >
                  <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span className="visually-hidden">Previous</span>
                </button>
                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#carouselExampleAutoplaying"
                  data-bs-slide="next"
                  style={{ opacity: '0.8' }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.opacity = '1';
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.opacity = '0.8';
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }}
                >
                  <span className="carousel-control-next-icon" aria-hidden="true"></span>
                  <span className="visually-hidden">Next</span>
                </button>
              </div>
            </ModalBody>
            <ModalFooter style={{ borderTop: '1px solid #e9ecef', background: '#f8f9fa' }}>
              <Button
                style={{
                  background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                  border: 'none',
                  borderRadius: '10px',
                  padding: '10px 25px',
                  fontWeight: '600'
                }}
                onClick={handleCloseModal}
              >
                <FontAwesomeIcon icon={faTimes} className="me-2" />
                Close
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </div>
    </>
  );
};

export default WarMemorials;
